import { findKey } from 'lodash-es';
import React, { type HTMLAttributes } from 'react';
import type { XOR } from 'ts-essentials';

import Icon, { type IconProps as IconComponentProps } from '#@/components/Icon';
import { COLOR } from '#@/shared/utils/styles';

import { Root, Text } from './Styles';

type BadgeProps = { color?: COLOR } & XOR<
  { count?: number | string },
  { icon?: IconComponentProps['type'] }
> &
  HTMLAttributes<HTMLDivElement>;

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ color = COLOR.textSecondary, count, icon, ...htmlProps }, ref) => {
    const cypressLabel = [icon, findKey(COLOR, (colorValue) => colorValue === color)]
      .filter(Boolean)
      .join('_');

    return (
      <Root
        $hasIcon={Boolean(icon)}
        $color={color}
        {...htmlProps}
        ref={ref}
        data-cy-badge={cypressLabel}
      >
        {icon ? <Icon size={10} type={icon} /> : <Text>{count}</Text>}
      </Root>
    );
  },
);

Badge.displayName = 'badge';

export default Badge;
